import { createReducer } from '@reduxjs/toolkit';
import {
    listStatsRequest,
    listStatsSuccess,
    listStatsFailure,
    listStatsChartRequest,
    listStatsChartSuccess,
    listStatsChartFailure,
    resetErrorRequest,
    ChartResponse,
    StatResponse,
} from './actions';

export interface StatState {
    stats: StatResponse | null;
    chart: ChartResponse | null;
    loading: boolean;
    error: string | null;
}

const initialState: StatState = {
    chart: null,
    stats: null,
    loading: false,
    error: null,
};

const statReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(resetErrorRequest, (state) => {
            state.error = null;
        })
        .addCase(listStatsRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listStatsSuccess, (state, action) => {
            state.stats = action.payload; // Set stats from the server
            state.loading = false;
        })
        .addCase(listStatsFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(listStatsChartRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listStatsChartSuccess, (state, action) => {
            state.loading = false;
            state.chart = action.payload;
        })
        .addCase(listStatsChartFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
});

export default statReducer;

